import DefaultFavIcon from "./Assets/logo.png";
import DefaultLogoMedium from "./Assets/logo.png";
import VNMapFavIcon from "./Assets/vnmap.favicon.ico.png";
import VNMapLogoMedium from "./Assets/vnmap.logo.png";
import PymidFavIcon from "./Assets/pymid.favicon.png";
import PymidLogoMedium from "./Assets/pymid.logo.jpg";

export const BRAND_BY_DOMAIN = {
  ...(process.env.REACT_APP_PROJECT === 'truyenthanh' ? {
    "default": {
      favicon: VNMapFavIcon,
      fullTitle: "Nền tảng truyền dẫn dữ liệu số, thông tin nguồn Phát Thanh-Truyền Hình VNMAP",
      fullTitleUp: "NỀN TẢNG TRUYỀN DẪN DỮ LIỆU SỐ, THÔNG TIN NGUỒN, PHÁT THANH-TRUYỀN HÌNH VNMAP",
      shortTitle: "VNMap",
      shortTitleUp: "VNMAP",
      logoMedium: VNMapLogoMedium,
      deviceShortLabel: "đài",
      deviceFullLabel: "đài phát",
      nodeLabel: "loa",
      companyName: "CÔNG TY CỔ PHẦN ĐẦU TƯ PHÁT TRIỂN CÔNG NGHỆ TÂN THANH PHƯƠNG",
      companyNameEn: 'TPC JOIN STOCK COMPANY',
      phone: '0237 888 6868',
      phoneEn: '+84 237 888 6868',
      fax: '0237 888 6869',
      faxEn: '+84 237 888 6869',
      address: 'Số 28 Cao Thắng, Phường Điện Biên, Thành phố Thanh Hóa, Tỉnh Thanh Hoá, Việt Nam',
      addressEn: '28 Cao Thang, District Dien Bien, Thanh Hoa City, Thanh Hoa Province, Vietnam',
      office: 'P2104, tòa B, Mỹ Sơn Tower, 62 Nguyễn Huy Tưởng, Quận Thanh Xuân, TP Hà Nội',
      officeEn: 'Number 2104, Tower B, My Son, 62 Nguyen Huy Tuong, Thanh Xuan District, Ha Noi',
      email: 'gm@tanthanhphuong.vn',
      iosApp: 'https://play.google.com/store/apps/details?id=vn.vnmap.qh',
      androidApp: 'https://apps.apple.com/us/app/vnmap3d/id1672712001',
    },
  } : {
    "default": {
      favicon: DefaultFavIcon,
      fullTitle: "iNut - Hệ sinh thái IoT",
      fullTitleUp: "INUT - Hệ sinh thái IoT",
      shortTitle: "iNut",
      shortTitleUp: "INUT",
      logoMedium: DefaultLogoMedium,
      deviceShortLabel: "cụm",
      deviceFullLabel: "cụm thiết bị",
      nodeLabel: "thiết bị",
      companyName: "INUT",
      companyNameEn: 'INUT JOIN STOCK COMPANY',
      phone: '097 276 8491',
      phoneEn: '+84 97 276 8491',
      address: '161 Trường Chinh, Phường 7, Thành phố Tuy Hòa, Tỉnh Phú Yên',
      addressEn: '161 Truong Chinh, Ward 7, Tuy Hoa City, Phu Yen Province, Vietnam',
    },
  }),

  "truyenthanh.vnmap3d.com": {
    favicon: VNMapFavIcon,
    fullTitle: "Nền tảng truyền dẫn dữ liệu số, thông tin nguồn Phát Thanh-Truyền Hình VNMAP",
    fullTitleUp: "NỀN TẢNG TRUYỀN DẪN DỮ LIỆU SỐ, THÔNG TIN NGUỒN, PHÁT THANH-TRUYỀN HÌNH VNMAP",
    shortTitle: "VNMap",
    shortTitleUp: "VNMAP",
    logoMedium: VNMapLogoMedium,
    deviceShortLabel: "đài",
    deviceFullLabel: "đài phát",
    nodeLabel: "loa",
    companyName: "CÔNG TY CỔ PHẦN ĐẦU TƯ PHÁT TRIỂN CÔNG NGHỆ TÂN THANH PHƯƠNG",
    companyNameEn: 'TPC JOIN STOCK COMPANY',
    phone: '0237 888 6868',
    phoneEn: '+84 237 888 6868',
    fax: '0237 888 6869',
    faxEn: '+84 237 888 6869',
    address: 'Số 28 Cao Thắng, Phường Điện Biên, Thành phố Thanh Hóa, Tỉnh Thanh Hoá, Việt Nam',
    addressEn: '28 Cao Thang, District Dien Bien, Thanh Hoa City, Thanh Hoa Province, Vietnam',
    office: 'P2104, tòa B, Mỹ Sơn Tower, 62 Nguyễn Huy Tưởng, Quận Thanh Xuân, TP Hà Nội',
    officeEn: 'Number 2104, Tower B, My Son, 62 Nguyen Huy Tuong, Thanh Xuan District, Ha Noi',
    email: 'gm@tanthanhphuong.vn',
    iosApp: 'https://play.google.com/store/apps/details?id=vn.vnmap.qh',
    androidApp: 'https://apps.apple.com/us/app/vnmap3d/id1672712001',
  },

  "iqair.vnmap3d.com": {
    favicon: VNMapFavIcon,
    fullTitle: "VNMAP IQAir",
    fullTitleUp: "VNMAP IQAir",
    shortTitle: "VNMap",
    shortTitleUp: "VNMAP",
    logoMedium: VNMapLogoMedium,
    deviceShortLabel: "cụm thiết bị",
    deviceFullLabel: "cụm thiết bị",
    nodeLabel: "trạm",
    redirectMap: {
      "/": "/aqi",
    },
    companyName: "CÔNG TY CỔ PHẦN ĐẦU TƯ PHÁT TRIỂN CÔNG NGHỆ TÂN THANH PHƯƠNG",
    companyNameEn: 'TPC JOIN STOCK COMPANY',
    phone: '0237 888 6868',
    phoneEn: '+84 237 888 6868',
    fax: '0237 888 6869',
    faxEn: '+84 237 888 6869',
    address: 'Số 28 Cao Thắng, Phường Điện Biên, Thành phố Thanh Hóa, Tỉnh Thanh Hoá, Việt Nam',
    addressEn: '28 Cao Thang, District Dien Bien, Thanh Hoa City, Thanh Hoa Province, Vietnam',
    office: 'P2104, tòa B, Mỹ Sơn Tower, 62 Nguyễn Huy Tưởng, Quận Thanh Xuân, TP Hà Nội',
    officeEn: 'Number 2104, Tower B, My Son, 62 Nguyen Huy Tuong, Thanh Xuan District, Ha Noi',
    email: 'gm@tanthanhphuong.vn',
    iosApp: 'https://play.google.com/store/apps/details?id=vn.vnmap.qh',
    androidApp: 'https://apps.apple.com/us/app/vnmap3d/id1672712001',
  },

  "center.pymid.com": {
    favicon: PymidFavIcon,
    fullTitle: "Trung Tâm PYMID",
    fullTitleUp: "TRUNG TÂM PYMID",
    shortTitle: "PYMID",
    shortTitleUp: "PYMID",
    logoMedium: PymidLogoMedium,
    deviceShortLabel: "cụm",
    deviceFullLabel: "cụm thiết bị",
    nodeLabel: "thiết bị",
    companyName: "INUT",
    companyNameEn: 'INUT JOIN STOCK COMPANY',
    phone: '097 276 8491',
    phoneEn: '+84 97 276 8491',
    address: '161 Trường Chinh, Phường 7, Thành phố Tuy Hòa, Tỉnh Phú Yên',
    addressEn: '161 Truong Chinh, Ward 7, Tuy Hoa City, Phu Yen Province, Vietnam',
  },

  "a.vnmap3d.com:3000": {
    favicon: VNMapFavIcon,
    fullTitle: "Nền tảng truyền dẫn dữ liệu số, thông tin nguồn Phát Thanh-Truyền Hình VNMAP",
    fullTitleUp: "NỀN TẢNG TRUYỀN DẪN DỮ LIỆU SỐ, THÔNG TIN NGUỒN, PHÁT THANH-TRUYỀN HÌNH VNMAP",
    shortTitle: "VNMap",
    shortTitleUp: "VNMAP",
    logoMedium: VNMapLogoMedium,
    deviceShortLabel: "đài",
    deviceFullLabel: "đài phát",
    nodeLabel: "loa",
    companyName: "CÔNG TY CỔ PHẦN ĐẦU TƯ PHÁT TRIỂN CÔNG NGHỆ TÂN THANH PHƯƠNG",
    companyNameEn: 'TPC JOIN STOCK COMPANY',
    phone: '0237 888 6868',
    phoneEn: '+84 237 888 6868',
    fax: '0237 888 6869',
    faxEn: '+84 237 888 6869',
    address: 'Số 28 Cao Thắng, Phường Điện Biên, Thành phố Thanh Hóa, Tỉnh Thanh Hoá, Việt Nam',
    addressEn: '28 Cao Thang, District Dien Bien, Thanh Hoa City, Thanh Hoa Province, Vietnam',
    office: 'P2104, tòa B, Mỹ Sơn Tower, 62 Nguyễn Huy Tưởng, Quận Thanh Xuân, TP Hà Nội',
    officeEn: 'Number 2104, Tower B, My Son, 62 Nguyen Huy Tuong, Thanh Xuan District, Ha Noi',
    email: 'gm@tanthanhphuong.vn',
    iosApp: 'https://play.google.com/store/apps/details?id=vn.vnmap.qh',
    androidApp: 'https://apps.apple.com/us/app/vnmap3d/id1672712001',
  },
}

export const AppLivestreamRecorderConfig = {
  recordingGain : 1, // Initial recording volume
  encoderBitRate : 64, // MP3 encoding bit rate
  streaming : true, // Data will be returned in chunks (ondataavailable callback) as it is encoded,
                    // rather than at the end as one large blob
  streamBufferSize : 1024, // Size of encoded mp3 data chunks returned by ondataavailable, if streaming is enabled
  constraints : { // Optional audio constraints, see https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia
    channelCount : 1, // Set to 2 to hint for stereo if it's available, or leave as 1 to force mono at all times
    // // autoGainControl : true,
    // echoCancellation : true,
    // noiseSuppression : true

    autoGainControl : false,
    echoCancellation : false,
    noiseSuppression : false
  },

  // Used for debugging only. Force using the older script processor instead of AudioWorklet.
  // forceScriptProcessor: true,
}

export const RamFactor = process.env.REACT_APP_RAM_FACTOR || 1;

// Fake CPU MHz rule: real RAM (MB, before RamFactor) >= this => real MHz + CPU_FREQ_BOOST, or random range if no real MHz
export const CPU_FREQ_BOOST_MIN_RAM = 1536;
export const CPU_FREQ_BOOST = 2000;
export const CPU_FREQ_BOOST_FAKE_MIN = 2500;
export const CPU_FREQ_BOOST_FAKE_MAX = 2899;

export const DISK_USAGE_ALERTING_RATIO = 85;
export const RAM_USAGE_ALERTING_RATIO = 84;
export const RAM_USAGE_WARNING_RATIO = 80;
export const RAM_NOT_USED_ALERTING_RATIO = 40;

export const ManifestDetails = {
  "short_name": process.env.REACT_APP_MANIFEST_NAME,
  "name": process.env.REACT_APP_MANIFEST_NAME,
  "icons": [
    {
      "src": "favicon.ico",
      "sizes": "64x64 32x32 24x24 16x16",
      "type": "image/x-icon"
    },
    {
      "src": "logo225.jpg",
      "type": "image/jpeg",
      "sizes": "225x225"
    }
  ],
  "start_url": ".",
  "display": "standalone",
  "theme_color": "#000000",
  "background_color": "#ffffff"
}

export const ControlTabInfoByPageQuery = {
  '': {
    port: 2023,
    tab_index: 0,
    tab_selection: true,
  },
  'fuxa': {
    port: 1881,
  },
  'iot-ui': {
    port: 2024,
    path: '',
    tab_selection: true,
  },
  'iot-admin': {
    port: 2024,
    path: '/admin',
  },
  'iot-2025': {
    port: 2025,
    path: '',
    tab_selection: true,
  },
  'iot-2025-admin': {
    port: 2025,
    path: '/admin',
  },
  'shinobi': {
    port: 8080,
  },
  'zigbee': {
    port: 18080,
  },
  'monitor-2030': {
    port: 2030,
  },
  'monitor-2031': {
    port: 2031,
  },
}